import { Component, Vue} from 'vue-property-decorator';
import { getConversionsMetrics } from './columns'

@Component
export default class ConversionsMetricsMixin extends Vue {
  get conversionsMetrics()  {
    let custom: { [type: string]: Bemob.MetricsHelpAggregated } = {};

    for(let i = 1; i <= 10; i++) {
      custom['reports-custom' + i] = {
        short: this.t('Name of traffic source parameter'),
        full: this.t('Additional traffic data, e.g. website ID, target ID or keyword according to the traffic source settings associated with particular conversion.')
      }

      custom[`reports-custom${i}masked`] = {
        short: this.t('Masked value of custom parameter'),
        full: this.t('Masked value of the corresponding parameter of traffic source.')
      }
    }

    const CONVERSIONS_METRICS = getConversionsMetrics()

    return{
      order: CONVERSIONS_METRICS.order,
      avaliable_metrics: CONVERSIONS_METRICS.allColumns,
      default_omit: CONVERSIONS_METRICS.defaultUnselected,
      default_include: CONVERSIONS_METRICS.defaultSelected,
      default_sort: CONVERSIONS_METRICS.defaultSort,
      metrics_help: {
        'reports-customevent': {
          short: this.t('The value of custom conversion'),
          full: this.t('Shows the value of custom conversion if available for the particular click ID.')
        },
        'conversions-postbacktimestamp': {
          short: this.t('Date and time of conversion'),
          full: this.t('The conversion is either displayed with Postback timestamp or Visit timestamp. The time settings can be configured in Settings -> General -> Reporting.')
        },
        'conversions-clickid': {
          short: this.t('Unique click ID'),
          full: this.t('Unique click ID value of conversion passed via postback. This value contains 22 alpha-numeric symbols.')
        },
        'reports-externalid': {
          short: this.t('Unique ID passed from traffic source'),
          full: this.t('Unique external ID passed from traffic source. Required for conversions data passing.')
        },
        'conversions-hiddenrevenue': {
          short: this.t('Revenue - Revenue of conversions sent to the traffic source via postback'),
          full: this.t('Shows the revenue of conversions which were not sent to the traffic source when Send Postbacks % option is active.')
        },
        'conversions-transactionid': {
          short: this.t('Unique transaction ID'),
          full: this.t('Transaction ID is passed from affiliate network via postback URL. As usual, value refers to unique order ID of conversion.')
        },
        'conversions-revenue': {
          short: this.t('Payout value of particular conversion'),
          full: this.t('Revenue reflects the amount of money earned for particular conversion.')
        },
        'conversions-cost': {
          short: this.t('Amount of money spent on conversion'),
          full: this.t('Indicates the amount of money which is paid for the traffic that turned into particular conversion.')
        },
        'conversions-postbackstatus': {
          short: this.t('Status value passed for a conversion via postback URL/pixel'),
          full: this.t('Conversion status is a value that is preconfigured in affiliate network settings and passed from affiliate network via postback URL/pixel.')
        },
        'conversions-useragent': {
          short: this.t('User agent data of a conversion'),
          full: this.t('User agent data of a conversion')
        },
        'reports-country': {
          short: this.t('Name of the country'),
          full: this.t('Name of the country associated with particular conversion event.')
        },
        'reports-os': {
          short: this.t('Operating system of device data'),
          full: this.t('Operating system of device from which the conversion was performed.')
        },
        'reports-osversion': {
          short: this.t('Version of operating system data'),
          full: this.t('Version of operating system from which the conversion was performed.')
        },
        'reports-devicetype': {
          short: this.t('Type of device data'),
          full: this.t('Type of device from which the conversion was performed.')
        },
        'reports-devicevendor': {
          short: this.t('Vendor of device data'),
          full: this.t('Vendor of device from which the conversion was performed.')
        },
        'reports-devicemodel': {
          short: this.t('Model of device data'),
          full: this.t('Model of device from which the conversion was performed.')
        },
        'reports-browser': {
          short: this.t('Name of browser data'),
          full: this.t('Name of browser from which the conversion was performed.')
        },
        'reports-browserversion': {
          short: this.t('Version of browser data'),
          full: this.t('Version of browser from which the conversion was performed.')
        },
        'reports-isp': {
          short: this.t('Internet service provider data'),
          full: this.t('Internet Service Provider of device from which the conversion was performed.')
        },
        'reports-mobilecarrier': {
          short: this.t('Mobile carrier of device data'),
          full: this.t('Mobile carrier of device from which the conversion was performed.')
        },
        'reports-connecttype': {
          short: this.t('Connection type data'),
          full: this.t('Connection type associated with the conversion event.')
        },
        'reports-ip': {
          short: this.t('IP address'),
          full: this.t('IP address associated with the conversion event.')
        },
        'reports-referrer': {
          short: this.t('Referrer data'),
          full: this.t('Referrer associated with the conversion event.')
        },
        'campaigns-id': {
          short: this.t('Unique ID of campaign'),
          full: this.t('Unique ID of campaign associated with conversion.')
        },
        'campaigns-name': {
          short: this.t('Name of campaign'),
          full: this.t('Custom campaign name related to the conversion event.')
        },
        'landings-id': {
          short: this.t('Unique ID of landing page'),
          full: this.t('Unique ID of landing page associated with conversion.')
        },
        'landings-name': {
          short: this.t('Name of landing'),
          full: this.t('Custom name of landing page associated with conversion event.')
        },
        'offers-id': {
          short: this.t('Unique ID of offer'),
          full: this.t('Unique ID of offer associated with conversion.')
        },
        'offers-name': {
          short: this.t('Offer name'),
          full: this.t('Custom name of offer related to the conversion event.')
        },
        'traffic_sources-id': {
          short: this.t('Unique ID of traffic source'),
          full: this.t('Unique ID of traffic source related to this conversion event.')
        },
        'traffic_sources-name': {
          short: this.t('Name of traffic source'),
          full: this.t('Name of traffic source associated with particular conversion.')
        },
        'affiliate_networks-id': {
          short: this.t('Unique ID of affiliate network'),
          full: this.t('Unique ID of affiliate network related to this conversion event.')
        },
        'affiliate_networks-name': {
          short: this.t('Name of affiliate network'),
          full: this.t('Name of affiliate network associated with particular conversion.')
        },
        'reports-customeventrevenue': {
          short: this.t('Payout of custom conversion'),
          full: this.t('Shows the payout of custom conversion received from the affiliate network or direct advertizer. ')
        },
        'reports-conversionconfirmhiddenrevenue': {
          short: this.t('Revenue of conversions with confirmed status that was not sent to the traffic source.'),
          full: this.t('Revenue of conversions with confirmed status that was not sent to the traffic source.')
        },
        'reports-conversionconfirmrevenue': {
          short: this.t('Revenue of conversions with confirmed status.'),
          full: this.t('Revenue of conversions with confirmed status.')
        },
        'flows-name': {
          short: this.t('Name of the flow associated to the event'),
          full: `${this.t('Name of the flow associated to the event')}.`,
        },
        'flows-id': {
          short: this.t('Unique ID of the flow associated to the event'),
          full: `${this.t('Unique ID of the flow associated to the event')}.`,
        },
        //Custom 1-10
        ...custom
      },
      metrics_options: CONVERSIONS_METRICS.weight,
      sort_exclude: CONVERSIONS_METRICS.sortExclude,
    } as Bemob.Metrics
  }
}
